// Lazy Image
(function() {
class ImageSrcSet extends HTMLElement {
  get intersecting() {
    return this.hasAttribute('intersecting');
  }  
  constructor() {
    super();
    this.slideLoadFrame = null;
    this.observerCallback = this.observerCallback.bind(this);
    this.loadImage = this.loadImage.bind(this);
    this.slideObserverCallback = this.slideObserverCallback.bind(this);
    this.onLoad = this.onLoad.bind(this);
  }
  connectedCallback() {
    this.img = this.querySelectorAll('img');
    this.productSlide = this.closest('.product-image-main .swiper-slide');
    this.img.forEach(item => item.addEventListener('load', this.onLoad));
    // Liquid already supplies real src/srcset/sizes and CSS makes this visible.
    // Do not measure, rewrite dimensions or observe the critical image.
    if (Array.from(this.img).some(item => item.loading === 'eager')) {
      this.removeAttribute('data-image-loading');
      return;
    }
    if (this.intersecting) return;
    if (this.productSlide) this.initSlideObserver();
    if ('IntersectionObserver' in window) this.initIntersectionObserver();else this.loadImage();
  }
  disconnectedCallback() {
    this.img?.forEach(item => item.removeEventListener('load', this.onLoad));
    this.cancelSlideLoad();
    this.disconnectObserver();
    this.disconnectSlideObserver();
  }
  loadImage() {
    if (this.intersecting) return;
    // One layout read before writes, only for deferred gallery sources. Keep
    // intrinsic dimensions and server-provided responsive sizes on other images.
    const hasDeferredSource = Array.from(this.img).some(item => item.dataset.srcset || item.dataset.src);
    const width = hasDeferredSource ? this.clientWidth : 0;
    this.setAttribute('intersecting', 'true');
    this.img.forEach(item => {
        if (item.dataset.srcset) {
          if (width > 0) item.sizes = width + 'px';
          item.srcset = item.dataset.srcset;
          delete item.dataset.srcset;
        }
        if (item.dataset.src) {
          item.src = item.dataset.src;
          delete item.dataset.src;
        }
    })
    this.img.forEach(item => {
        item.classList.add('res-img-loaded');
    })
    if (Array.from(this.img).every(item => item.complete && item.naturalWidth > 0)) this.onLoad();
    this.disconnectObserver();
    this.disconnectSlideObserver();
  }
  onLoad() {
    this.removeAttribute('data-image-loading');
  }
  observerCallback(entries, observer) {
    if (!entries[0].isIntersecting) return;
    const hasEagerImage = Array.from(this.img).some(item => item.loading === 'eager');
    if (this.productSlide && !this.productSlide.classList.contains('swiper-slide-active') && !hasEagerImage) return;
    observer.unobserve(this);
    this.loadImage();
  }
  slideObserverCallback() {
    this.cancelSlideLoad();
    this.slideLoadFrame = requestAnimationFrame(() => {
      this.slideLoadFrame = null;
      if (!this.productSlide.classList.contains('swiper-slide-active')) return;
      this.disconnectObserver();
      this.disconnectSlideObserver();
      this.loadImage();
    });
  }
  cancelSlideLoad() {
    if (this.slideLoadFrame === null) return;
    cancelAnimationFrame(this.slideLoadFrame);
    this.slideLoadFrame = null;
  }
  initSlideObserver() {
    if (this.slideObserver) return;
    this.slideObserver = new MutationObserver(this.slideObserverCallback);
    this.slideObserver.observe(this.productSlide, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  disconnectSlideObserver() {
    if (!this.slideObserver) return;
    this.slideObserver.disconnect();
    this.slideObserver = null;
    delete this.slideObserver;
  }
  initIntersectionObserver() {
    if (this.observer) return;
    const rootMargin = '10px';
    this.observer = new IntersectionObserver(this.observerCallback, {
      rootMargin
    });
    this.observer.observe(this);
  }
  disconnectObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
    delete this.observer;
  }
}
customElements.define('image-srcset', ImageSrcSet);
})();
